import type {CommonProps} from './types';

export default ({color = '#58595B', size = 24, ...rest}: CommonProps) => (
  <svg aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    width={size}
    viewBox="0 0 24 24"
    {...rest}
  >
    <g
      stroke={color}
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.75.75v22.5" />
      <path d="M.75 2.25H22.5a.75.75 0 0 1 .56 1.25l-4 4.5a1.5 1.5 0 0 0 0 2l4 4.5a.75.75 0 0 1-.56 1.25H.75" />
    </g>
  </svg>
);
